var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-inline-flex align-center",
    staticStyle: {
      "border-radius": "4px"
    }
  }, [_c('v-text-field', _vm._g({
    ref: "input",
    staticClass: "white",
    staticStyle: {
      "margin-right": "-1px",
      "border-right": "none"
    },
    attrs: {
      "persistent-placeholder": "",
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "hide-spin-buttons": "",
      "type": "number",
      "label": _vm.label,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "min": _vm.min,
      "max": _vm.max,
      "step": _vm.step,
      "rules": [function (v) {
        return !_vm.required && !v || _vm.isInt(v) && parseInt(v) >= _vm.min && parseInt(v) <= _vm.max;
      }].concat(_vm.rules.map(function (rule) {
        return function (v) {
          return rule(parseInt(v));
        };
      })),
      "value": _vm.value
    }
  }, Object.assign({}, _vm.$listeners, {
    input: _vm.input
  }))), !_vm.hideStepper ? _c('div', {
    staticClass: "ml-3 flex-grow-0 btn-group btn-group-horizontal",
    staticStyle: {
      "border-radius": "4px",
      "user-select": "none"
    }
  }, [_c('v-btn', {
    staticClass: "px-3 outline-hover white",
    staticStyle: {
      "height": "40px",
      "margin-right": "-.5px"
    },
    attrs: {
      "text": "",
      "color": "primary",
      "disabled": _vm.disabled || _vm.isInt(_vm.value) && parseInt(_vm.value) <= _vm.min
    },
    on: {
      "click": function ($event) {
        return _vm.inc(-1);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiMinus)
    }
  })], 1), _c('v-btn', {
    staticClass: "px-3 outline-hover white",
    staticStyle: {
      "height": "40px",
      "margin-left": "-.5px"
    },
    attrs: {
      "text": "",
      "color": "primary",
      "disabled": _vm.disabled || _vm.isInt(_vm.value) && parseInt(_vm.value) >= _vm.max
    },
    on: {
      "click": function ($event) {
        return _vm.inc(1);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiPlus)
    }
  })], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }